export const MfcStringUtilities = {
    _hTemplateCache: {},
    _hTemplatePWSCache: {},
    _rTemplateRegex: /\t+|\r+|\n+|\s\s+|\u2028|\u2029|\\|'|%\w+%/g,
    _rTemplatePWSRegex: /\\|'|\r|\n|\u2028|\u2029|%\w+%/g,
    _hTemplateEscapes: {
        "'": "'",
        '\\': '\\',
    },
    _hTemplatePWSEscapes: {
        "'": "'",
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        '\u2028': 'u2028',
        '\u2029': 'u2029',
    },
    _fTemplateReplaceFn: function (match: string) {
        const sEscape = MfcStringUtilities._hTemplateEscapes[match]
        if (sEscape) return '\\' + sEscape
        if (match.charAt(0) === '%')
            return "' + (obj['" + match.slice(1).toLowerCase() + "']||'') + '"
        return ' '
    },
    _fTemplatePWSReplaceFn: function (match: string) {
        const sEscape = MfcStringUtilities._hTemplatePWSEscapes[match]
        if (sEscape) return '\\' + sEscape
        return "' + (obj." + match.slice(1).toLowerCase() + "||'') + '"
    },
    char_padding: function (
        sString: string,
        nWidth: number,
        cChar: string,
        sDirection?: string,
    ) {
        if (typeof cChar === 'undefined') {
            cChar = ' '
        }
        if (typeof sString === 'undefined') {
            return
        }
        sString = sString.toString()
        let nDec = ''
        let cSign = ''
        if (sString.match(/^[\d.-]+$/)) {
            if (sString.charAt(0) === '-') {
                sString = sString.slice(1)
                cSign = '-'
            }
            if (sString.indexOf('.') === -1) {
                sString += '.'
            }
            nDec = sString.split('.')[1]
            sString = sString.split('.')[0]
        }
        while (sString.length < nWidth) {
            if (sDirection === 'right') {
                sString = sString + cChar
            } else {
                sString = cChar + sString
            }
        }
        if (sString.match(/\d/)) {
            sString = cSign + sString
            if (nDec) {
                sString += '.' + nDec
            }
        }
        return sString
    },
    qs_from_obj: function (obj: object) {
        const str = []
        for (const p in obj) {
            if (Object.hasOwnProperty.call(obj, p)) {
                str.push(
                    encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]),
                )
            }
        }
        return str.join('&')
    },
    parse_query_string: function (sQueryString: string) {
        const hQS: any[] = []
        let aPairs: any[] = []
        if ((aPairs = sQueryString.replace(/\?/g, '&').split('&'))) {
            for (let i = 0; i < aPairs.length; i++) {
                let sKey = aPairs[i].split('=')[0]
                let sVal = aPairs[i].split('=')[1]
                if (typeof sKey === 'string') sKey = sKey.replace(/\W/g, '')
                if (typeof sVal === 'string') {
                    sVal = decodeURIComponent(sVal).replace(/[<>"'`]/g, '')
                    if (!isNaN(sVal)) {
                        sVal = parseFloat(sVal)
                    }
                }
                hQS[sKey] = isNaN(sVal) ? sVal || '' : sVal
            }
        }
        return hQS
    },
    parse_template: function (
        sTemplate: string,
        hSwaps: object,
        hOptions: any,
    ) {
        if (!sTemplate) {
            return
        }
        if (!hSwaps) {
            hSwaps = {}
        }
        if (!hOptions) {
            hOptions = {}
        }
        hOptions.preserve_white_space = hOptions.preserve_white_space ? 1 : 0
        const hTemplateCache = hOptions.preserve_white_space
            ? MfcStringUtilities._hTemplatePWSCache
            : MfcStringUtilities._hTemplateCache
        let fTemplate: any = hTemplateCache[sTemplate]
        if (!fTemplate) {
            let rRegex: RegExp
            let fReplace: (match: string) => string
            if (hOptions.preserve_white_space) {
                rRegex = MfcStringUtilities._rTemplatePWSRegex
                fReplace = MfcStringUtilities._fTemplatePWSReplaceFn
            } else {
                rRegex = MfcStringUtilities._rTemplateRegex
                fReplace = MfcStringUtilities._fTemplateReplaceFn
            }
            // eslint-disable-next-line @typescript-eslint/no-implied-eval
            fTemplate = hTemplateCache[sTemplate] = new Function(
                'obj',
                "return '" + sTemplate.replace(rRegex, fReplace) + "';",
            )
        }
        return fTemplate(hSwaps)
    },
    query_string_append: function (
        sString: string,
        sKey: string,
        sValue: string,
    ) {
        let sHash = ''
        if (sString.indexOf('#') > -1) {
            sHash = sString.substring(sString.indexOf('#'), sString.length)
            sString = sString.substring(0, sString.indexOf('#'))
        }
        let sJoint = ''
        if (sString.match(/&$/)) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            1
        } else if (sString.match(/\?/)) {
            sJoint = '&'
        } else {
            sJoint = '?'
        }
        return sString + sJoint + sKey + '=' + sValue + sHash
    },
}
